<template>
  <component :is="currentComponent"></component>
</template>

<script>
import WeightLossContentEn from './WeightLossContent/WeightLossContentEn.vue';
import WeightLossContentPtBR from './WeightLossContent/WeightLossContentPtBR.vue';
import WeightLossContentEs from './WeightLossContent/WeightLossContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return WeightLossContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return WeightLossContentEs;
      }
      return WeightLossContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
